// Content-Security-Policy nonce injected into index.html by the backend (see ContentSecurityPolicy.cs).
// Style elements created at runtime must carry it, as the CSP doesn't allow 'unsafe-inline' styles.
// This module must be imported before any module that injects styles.
declare let __webpack_nonce__: string | undefined

export const cspNonce =
  document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content ?? undefined

// Lets webpack tag the elements it injects (style-loader in development, lazy loaded chunks)
if (cspNonce) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- read by webpack's runtime
  __webpack_nonce__ = cspNonce
}
